import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-i18n-complement-ids',
  templateUrl: './i18n-complement-ids.component.html',
  styleUrls: ['./i18n-complement-ids.component.css']
})
export class I18nComplementIdsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
